import Vue from 'vue';
import VueRouter from 'vue-router';
// import i18n from '../i18n';
// Views
import VerifyAccount from '../views/VerifyAccount.vue';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Story from '../views/Story.vue';
import Chapter from '../views/Chapter.vue';
import PageError from '../views/PageError.vue';
import Privacy from '../views/Privacy.vue';
import DeleteData from '../views/DeleteData.vue';
import TermsAndConditions from '../views/TermsAndConditions.vue';
import NoExhibition from '../views/NoExhibition.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Root',
    component: {
      template: '<router-view></router-view>'
    }
  },
  {
    path: '/:locale',
    component: {
      template: '<router-view></router-view>'
    },
    // beforeEnter: (to, from, next) => {
    //   const { locale, id } = to.params;
    //   const supportedLocales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
    //   if (!supportedLocales.includes(locale)) return next(`en/${id}`);
    //   if (i18n.locale !== locale) {
    //     i18n.locale = locale;
    //   }
    // return next();
    // },
    children: [
      {
        path: 'privacy',
        name: 'Privacy',
        component: Privacy
      },
      {
        path: 'data-deletion',
        name: 'DeleteData',
        component: DeleteData
      },
      {
        path: 'terms-and-conditions',
        name: 'TermsAndConditions',
        component: TermsAndConditions
      },
      {
        path: 'no-exhibition',
        name: 'NoExhibition',
        component: NoExhibition
      },
      {
        path: ':id',
        name: 'Home',
        component: Home,
      },
      {
        path: ':id/chapters/:chapterId',
        name: 'Chapter',
        component: Chapter,
      },
      {
        path: ':id/stories/:storyId',
        name: 'Story',
        component: Story,
      },
      {
        path: ':id/login',
        name: 'Login',
        component: Login,
      },
      {
        path: ':id/verify-account',
        name: 'VerifyAccount',
        component: VerifyAccount,
      },
      {
        path: ':id/error',
        name: 'PageError',
        component: PageError,
      },
      {
        path: ':id/*',
        name: 'PageError2',
        component: PageError,
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
